export enum LabelStyle {
  DEFAULT = 'Default',
  FLAG = 'Flag'
}
